// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.editor_olW3x {
  min-height: 400px;
  min-width: 800px;
  max-width: 80vw;
  max-height: 80vh;
  position : relative;
}

.gridContainer_q9Jwu {
  display : grid;
  row-gap : var( --size-padLarge, 16px );
  align-items: center;
  padding : var( --size-padMedium, 8px );
}

.gridItem_Tk6Nx {
  display : flex;
  flex-direction : column;
}
`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/api-ui-user-management/lib/user/User.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,sCAAsC;EACtC,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,cAAc;EACd,uBAAuB;AACzB","sourcesContent":[".editor {\n  min-height: 400px;\n  min-width: 800px;\n  max-width: 80vw;\n  max-height: 80vh;\n  position : relative;\n}\n\n.gridContainer {\n  display : grid;\n  row-gap : var( --size-padLarge, 16px );\n  align-items: center;\n  padding : var( --size-padMedium, 8px );\n}\n\n.gridItem {\n  display : flex;\n  flex-direction : column;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"editor": `editor_olW3x`,
	"gridContainer": `gridContainer_q9Jwu`,
	"gridItem": `gridItem_Tk6Nx`
};
export default ___CSS_LOADER_EXPORT___;
